import { IonCard } from '@ionic/react';
import { FC } from 'react';
import { JobLogV2Data } from 'src/utils/logs/types';
import JobClampPressureGraph from './JobClampPressureGraph';
import JobInletPressureGraph from './JobInletPressureGraph';
import JobWaterPressureGraph from './JobWaterPressureGraph';

interface JobPressureCardProps {
  /** Clamp pressure data */
  clampData: JobLogV2Data['clamp'] | undefined;
  /** Inlet pressure data */
  inletData: JobLogV2Data['inlet'] | undefined;
  /** Water pressure data */
  waterData: JobLogV2Data['water'] | undefined;
  /** The time table used to correlate events with their calendary time. */
  timeTable: JobLogV2Data['timeTable'] | undefined;
  /** Time range min value */
  timeRangeMin: number;
  /** Time range max value */
  timeRangeMax: number;
  /** The timezone associated with the job log. */
  timezone: string;
  showTimestamps: boolean;
}

const JobPressureCard: FC<JobPressureCardProps> = ({
  clampData,
  inletData,
  waterData,
  timeTable,
  timeRangeMin,
  timeRangeMax,
  showTimestamps,
  timezone,
}) => {
  return (
    <IonCard className="job-graph-card">
      <JobClampPressureGraph
        clampData={clampData}
        timeTable={timeTable}
        timeRangeMin={timeRangeMin}
        timeRangeMax={timeRangeMax}
        showTimestamps={showTimestamps}
        timezone={timezone}
      />
      <JobInletPressureGraph
        inletData={inletData}
        timeTable={timeTable}
        timeRangeMin={timeRangeMin}
        timeRangeMax={timeRangeMax}
        showTimestamps={showTimestamps}
        timezone={timezone}
      />
      <JobWaterPressureGraph
        waterData={waterData}
        timeTable={timeTable}
        timeRangeMin={timeRangeMin}
        timeRangeMax={timeRangeMax}
        showTimestamps={showTimestamps}
        timezone={timezone}
      />
    </IonCard>
  );
};

export default JobPressureCard;
